import { fetchSingleTarget, saveTarget } from '@/api'
import { TARGET_TYPE, TARGET_TYPES_INTEGERS } from '@/appLogic/targets/Constants'
import { getAllDatasetsRootFamilyFromQuery } from '@/common/U'

class WorkbenchInterface {
  /**
   * This should pass the interface to the current store, so that the other store
   * can communicate with this interface
   * @param {*} context - this is the VueX context object
   */
  setInterface(context) {
    throw Error('Not Implemented')
  }

  getTargetAndDatasourceInformation(query) {
    const DATASET_TO_TARGET = {
      amrld: TARGET_TYPE.LAS,
      mri: TARGET_TYPE.LAS,
      ncs: TARGET_TYPE.LAS,
      xandr: TARGET_TYPE.XANDR_SEGMENT,
      adstra: TARGET_TYPE.ADSTRA,
      prism: TARGET_TYPE.PRISM,
      dnb: TARGET_TYPE.DNB,
      max: TARGET_TYPE.MAX,
      byod: TARGET_TYPE.BYOD,
      tve: TARGET_TYPE.TVE,
      epsilon: TARGET_TYPE.EPSILON,
      'd+': TARGET_TYPE.DISCOVERY_PLUS,
      dcr: TARGET_TYPE.DCR,
      videoamp: TARGET_TYPE.VIDEOAMP,
      liveramp: TARGET_TYPE.LIVERAMP,
      wbgames: TARGET_TYPE.WBGAMES,
      retargeting: TARGET_TYPE.RETARGETING,
      FreeWheel: TARGET_TYPE.FREEWHEEL,
      GoogleAdManager: TARGET_TYPE.GOOGLE_AD_MANAGER,
      LAL: TARGET_TYPE.LAL,
      dc_comics: TARGET_TYPE.DC_COMICS,
      cnn: TARGET_TYPE.CNN,
    }
    const DATASET_TO_TARGET_TYPE = {
      mri: TARGET_TYPES_INTEGERS.LAS,
      amrld: TARGET_TYPES_INTEGERS.LAS,
      ncs: TARGET_TYPES_INTEGERS.LAS,
      xandr: TARGET_TYPES_INTEGERS.ADSTRA,
      adstra: TARGET_TYPES_INTEGERS.ADSTRA,
      prism: TARGET_TYPES_INTEGERS.PRISM,
      dnb: TARGET_TYPES_INTEGERS.DNB,
      max: TARGET_TYPES_INTEGERS.MAX,
      byod: TARGET_TYPES_INTEGERS.BYOD,
      tve: TARGET_TYPES_INTEGERS.TVE,
      epsilon: TARGET_TYPES_INTEGERS.EPSILON,
      'd+': TARGET_TYPES_INTEGERS.DISCOVERY_PLUS,
      dcr: TARGET_TYPES_INTEGERS.DCR,
      videoamp: TARGET_TYPES_INTEGERS.VIDEOAMP,
      liveramp: TARGET_TYPES_INTEGERS.LIVERAMP,
      wbgames: TARGET_TYPES_INTEGERS.WBGAMES,
      retargeting: TARGET_TYPES_INTEGERS.RETARGETING,
      FreeWheel: TARGET_TYPES_INTEGERS.FREEWHEEL,
      GoogleAdManager: TARGET_TYPES_INTEGERS.GOOGLE_AD_MANAGER,
      LAL: TARGET_TYPES_INTEGERS.LAL,
      dc_comics: TARGET_TYPES_INTEGERS.DC_COMICS,
      cnn: TARGET_TYPES_INTEGERS.CNN,
    }
    // datasets with restrictions on compatibility or destination types
    const R_DATASETS = ['mri', 'ncs', 'dnb', 'max', 'byod', 'tve']

    let datasetFamilies = getAllDatasetsRootFamilyFromQuery(query)
    if (datasetFamilies.length >= 1) {
      // give preference to restricted datasets for setting the target type
      let df = datasetFamilies.find(ds => R_DATASETS.includes(ds)) || datasetFamilies[0]
      return {
        target: DATASET_TO_TARGET[df],
        target_datasource: df,
        target_type: DATASET_TO_TARGET_TYPE[df],
      }
    } else {
      throw Error("Couldn't find target datasource from the definition")
    }
  }

  getTarget(targetInfo) {
    return fetchSingleTarget({ target_id: targetInfo.id }).then(resp => resp.data)
  }

  saveTarget(targetInfo) {
    throw Error('Not Implemented')
  }

  onTargetDefinitionChange(targetDefinition) {
    throw Error('Not Implemented')
  }

  getTargetDefinition(getters) {
    throw Error('Not Implemented')
  }

  submitDownstream() {
    throw Error('Not Implemented')
  }

  queryForData() {
    throw Error('Not Implemented')
  }

  sendDownStream() {
    throw Error('Not Implemented')
  }

  onSetTarget() {
    throw Error('Not Implemented')
  }

  reset(context) {
    throw Error('Not Implemented')
  }

  /**
   * @returns [{name, module}, ......]
   */
  getStoreModules() {
    return []
  }

  getDefaultTarget(targetInfo) {
    return {}
  }

  /**
   * When there is a duplicate on create
   */
  onDuplicate() {
    throw Error('Not Implemented')
  }

  /**
   * When the view is created
   */
  onCreate() {
    throw Error('Not Implemented')
  }

  model() {
    throw Error('Not Implemented')
  }

  onSetAdvertiser() {
    throw Error('onSetAdvertiser not Implemented')
  }
}

export default WorkbenchInterface



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/WorkbenchInterface.js